import Grid2 from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import { FieldsetWrapper } from 'src/shared/components/Form/FieldsetWrapper';
import { TextField } from 'src/shared/components/Form/TextField';
import { useTranslation } from 'react-i18next';
import { GRID_COLUMN_CONFIG } from '../../../consts';
import { Typography } from '@mui/material';
import { type CardStatusToDisplay } from 'src/modules/Flexflow/EmployeeDetails/types';
import EmployeeFlexflowStatus from 'src/modules/Flexflow/components/EmployeeFlexflowStatus';
import WithIcon from 'src/modules/Flexflow/EmployeeDetails/Feature/WithIcon';
import DownloadIcon from '@mui/icons-material/Download';

type CardInformationColumnProps = {
  data?: {
    title: string;
    status?: CardStatusToDisplay;
    createdAt?: string;
    cardToken?: string;
    novationDetails?: { signedURL?: string };
  };
};

const ADORNMENT_ONLY_INPUT_SX = {
  '& input': {
    width: 0,
    minWidth: 0,
    flexGrow: 0,
    paddingLeft: 0,
    paddingRight: 0,
    overflow: 'hidden'
  }
};

const fillStartAdornment = (content: React.ReactNode) => (
  <span style={{ width: '100%', display: 'flex', alignItems: 'center' }}>{content}</span>
);

export const CardInformationColumn = ({ data }: CardInformationColumnProps) => {
  const { t } = useTranslation(['flexflow']);

  return (
    <Grid2 {...GRID_COLUMN_CONFIG}>
      <Grid2 mb={2} sx={{ px: 0 }}>
        <Typography variant="h4" sx={{ fontWeight: 400 }}>
          {data?.title}
        </Typography>
      </Grid2>
      <Grid2 sx={{ px: 0 }}>
        <FieldsetWrapper disabled>
          <TextField
            name="dateOfIssue"
            label={t('date of issue', { ns: 'flexflow' })}
            value={data?.createdAt ? moment(data?.createdAt).format('DD/MM/YYYY') : '-'}
          />
        </FieldsetWrapper>
      </Grid2>
      <Grid2 sx={{ px: 0 }}>
        <FieldsetWrapper disabled>
          <TextField
            name="cardIdentifier"
            label={t('card identifier', { ns: 'flexflow' })}
            value={data?.cardToken ? data?.cardToken : '-'}
          />
        </FieldsetWrapper>
      </Grid2>
      <Grid2 sx={{ px: 0 }}>
        <FieldsetWrapper disabled>
          <TextField
            name="novacionDocument"
            label={t('novacion document', { ns: 'flexflow' })}
            InputProps={{
              readOnly: true,
              sx: ADORNMENT_ONLY_INPUT_SX,
              startAdornment: fillStartAdornment(
                data?.novationDetails?.signedURL ? (
                  <a href={data?.novationDetails?.signedURL} target="_blank" download style={{ width: '100%' }}>
                    <WithIcon icon={<DownloadIcon />} label={t('download', { ns: 'flexflow' })} />
                  </a>
                ) : (
                  '-'
                )
              )
            }}
          />
        </FieldsetWrapper>
      </Grid2>
      <Grid2 sx={{ px: 0 }}>
        <FieldsetWrapper disabled>
          <TextField
            width="100%"
            label={t('field.status', { ns: 'form' })}
            InputProps={{
              readOnly: true,
              sx: ADORNMENT_ONLY_INPUT_SX,
              startAdornment: fillStartAdornment(<EmployeeFlexflowStatus cardStatus={data?.status} />)
            }}
            value=""
            name="status"
          />
        </FieldsetWrapper>
      </Grid2>
    </Grid2>
  );
};
